import { useState } from 'react';
import { TextField } from './TextField';

type PasswordFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  className?: string;
};

export const PasswordField: React.FC<PasswordFieldProps> = ({
  value,
  onChange,
  placeholder,
  error,
  className,
}: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      error={error}
      className={className}
      type={showPassword ? 'text' : 'password'}
      suffix={
        <button
          onClick={() => setShowPassword((prev) => !prev)}
          className="bg-transparent border-none cursor-pointer p-0 flex items-center justify-center"
        >
          <img src="/show_password.svg" alt="Toggle password visibility" className="w-4 h-4" />
        </button>
      }
    />
  );
};
